module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAABTCAIAAACebPnyAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAH1JREFUeNrs1jEOgCAMAEAb/v9mHFwIOhiEBpPrxHa0hUI51kdhMBgMBoPBYDAYjCRjPGqty4H3RnzJICKWGO32lxhdfeYbbYmu9WSj68F8497kycbjKfphHkn9SDpXSfcj6Z6PzauMubvx++HPwGAwGAwGg8FgMLY0TgEGANntTr/N7CwJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/previous-project.png
// module id = 550
// module chunks = 278158968741676